import "@arco-design/web-react/es/Tooltip/style";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import React, { useContext, useRef, useState } from 'react';
import qs from 'qs';
import { BaseContext } from '@/contexts/BaseContext';
import { LocalesList } from '@/constants/i18n'; // import '@arco-design/web-react/es/Select/style/index.less';

import styles from './index.module.scss';

const Language = ({
  tooltip = ''
}) => {
  const boxRef = useRef(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [selectVisible, setSelectVisible] = useState(false);
  const {
    language
  } = useContext(BaseContext);

  if (language.supports.length <= 1) {
    return null;
  }

  const curLang = language.current;

  const handleLanguage = lang => {
    const query = qs.parse(location.search.slice(1));

    if (LocalesList.includes(lang)) {
      query.lang = lang;
      window.location.search = qs.stringify(query);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    ref: boxRef,
    className: styles.container,
    onMouseEnter: () => !selectVisible && setPopupVisible(true),
    onMouseLeave: () => setPopupVisible(false)
  }, /*#__PURE__*/React.createElement(_Tooltip, {
    color: "#474E66",
    position: "lt",
    popupVisible: Boolean(tooltip) && popupVisible,
    getPopupContainer: () => boxRef.current,
    style: {
      width: 214,
      left: -214
    },
    content: tooltip
  }, /*#__PURE__*/React.createElement(_Select, {
    onClick: () => {
      setPopupVisible(false);
    },
    options: language.supports,
    defaultValue: curLang,
    onChange: handleLanguage,
    onVisibleChange: visible => setSelectVisible(visible),
    bordered: false,
    getPopupContainer: node => node.parentNode,
    triggerProps: {
      className: styles.popup,
      position: 'br',
      style: {
        width: 'auto',
        minWidth: 150
      }
    }
  })));
};

export default Language;